import type { IconProp } from 'components/common/icons/Icon';

interface Params {
  defaultColor: string;
  mimeType?: string;
  url: string;
}

const getFileType = ({ defaultColor, mimeType, url }: Params) => {
  const extension = url.split('.').pop();

  let type = 'file';

  if (mimeType?.startsWith('image/')) {
    type = 'image';
  } else if (mimeType?.startsWith('video/')) {
    type = 'video';
  } else if (mimeType) {
    type =
      {
        'application/pdf': 'pdf',
        'application/msword': 'word',
        'application/vnd.oasis.opendocument.text': 'word',
        'application/vnd.openxmlformats-officedocument.wordprocessingml':
          'word',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          'word',
        'application/vnd.ms-powerpoint': 'powerpoint',
        'application/vnd.oasis.opendocument.presentation': 'powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml':
          'powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          'powerpoint',
        'application/vnd.ms-excel': 'excel',
        'application/vnd.oasis.opendocument.spreadsheet': 'excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml': 'excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          'excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.spreadsheet':
          'excel',
        'application/zip': 'archive'
      }[mimeType] || 'file';
  } else if (extension) {
    type =
      {
        aac: 'audio',
        avi: 'video',
        doc: 'word',
        docx: 'word',
        gif: 'image',
        jpeg: 'image',
        jpg: 'image',
        mov: 'video',
        mp3: 'audio',
        mp4: 'video',
        pdf: 'pdf',
        png: 'image',
        ppt: 'powerpoint',
        pptx: 'powerpoint',
        svg: 'image',
        wav: 'audio',
        webp: 'image',
        xlsx: 'excel',
        zip: 'archive'
      }[extension.toLowerCase()] || 'file';
  }

  const icon = {
    audio: ['far', 'file-audio'],
    archive: ['far', 'file-archive'],
    excel: ['far', 'file-excel'],
    file: ['far', 'file'],
    image: ['far', 'file-image'],
    pdf: ['far', 'file-pdf'],
    powerpoint: ['far', 'file-powerpoint'],
    video: ['far', 'file-video'],
    word: ['far', 'file-word']
  }[type] as IconProp;

  const iconColor = {
    audio: defaultColor,
    archive: '#edc217',
    excel: '#217346',
    file: defaultColor,
    image: defaultColor,
    pdf: '#F40F02',
    powerpoint: '#d24726',
    video: defaultColor,
    word: '#2b579a'
  }[type];

  return {
    icon,
    iconColor,
    type
  };
};

export default getFileType;
